// Mostra o veículo ativo e a garagem em qualquer página: faixa do desktop (pill + "ver produtos",
// "trocar", "meus veículos"), linha do celular, gaveta do seletor ("Comprando para") e o "Meu veículo"
// da barra inferior. Repinta sem recarregar no evento arpine:veiculo-alterado.
// Nomes de veículo vêm da URL/localStorage: SEMPRE textContent, nunca innerHTML.
window.ArpineDS.etapa?.("veiculo-ui: importando core");
const core = await window.ArpineDS.importar("core");
window.ArpineDS.etapa?.("veiculo-ui: core ok; importando garagem");
const { garagem, pintarSilhuetas } = await window.ArpineDS.importar("garagem");
window.ArpineDS.etapa?.("veiculo-ui: garagem ok");
const cfg = window.ArpineDS;

function itemGaragem(v, ativo) {
  const li = document.createElement("li");
  li.className = ativo ? "ds-garage__item is-ativo" : "ds-garage__item";
  const usar = document.createElement("button");
  usar.type = "button";
  usar.className = "ds-garage__usar";
  usar.dataset.usar = v.id;
  usar.setAttribute("aria-pressed", String(ativo));
  const icone = document.createElement("span");
  icone.setAttribute("data-ds-silhueta", "");
  const nome = document.createElement("span");
  nome.textContent = core.labelVeiculo(v);
  usar.append(icone, nome);
  const remover = document.createElement("button");
  remover.type = "button";
  remover.className = "ds-garage__remover";
  remover.dataset.remover = v.id;
  remover.textContent = "remover";
  remover.setAttribute("aria-label", `Remover ${core.labelVeiculo(v)}`);
  li.append(usar, remover);
  pintarSilhuetas(li, v.tipo);
  return li;
}

function render() {
  const g = garagem.get();
  const v = core.activeVehicle(g);
  const nome = v ? core.labelVeiculo(v) : "";
  const pagina = v ? core.vehiclePageUrl(cfg.vehiclePage, v) : cfg.vehiclePage;

  document.querySelectorAll("[data-ds-veiculo-nome]").forEach((el) => { el.textContent = nome; });
  document.querySelectorAll("[data-ds-ver-produtos], [data-ds-meu-veiculo]").forEach((a) => { a.href = pagina; });
  document.querySelectorAll("[data-ds-linha-texto]").forEach((el) => {
    el.textContent = v ? `${nome} · trocar` : "Selecione seu veículo";
  });
  document.querySelectorAll("[data-ds-strip]").forEach((el) => {
    if (!(el.dataset.estado === "trocando" && v)) el.dataset.estado = v ? "veiculo" : "vazio";
  });
  // silhueta do ativo em tudo; depois as listas, que pintam cada item com o tipo dele
  pintarSilhuetas(document.body, v?.tipo);
  document.querySelectorAll("[data-ds-garage-list]").forEach((ul) => {
    ul.replaceChildren(...g.veiculos.map((x) => itemGaragem(x, x.id === g.ativo)));
  });
  document.querySelectorAll("[data-ds-garage]").forEach((box) => { box.hidden = g.veiculos.length === 0; });
}

// Região viva (educada) pra leitor de tela: anuncia troca e remoção de veículo.
const anuncio = document.createElement("p");
anuncio.className = "ds-sr-only";
anuncio.setAttribute("aria-live", "polite");
anuncio.setAttribute("data-ds-anuncio", "");
document.body.append(anuncio);
function anunciar(texto) {
  anuncio.textContent = "";
  setTimeout(() => { anuncio.textContent = texto; }, 50);
}

// render() troca os itens da lista (replaceChildren): o botão clicado sai do DOM. O foco vai pra um
// lugar que continua existindo, pra quem navega pelo teclado não voltar ao início da página.
document.addEventListener("click", (e) => {
  const usar = e.target.closest?.("[data-usar]");
  if (usar) {
    const menu = usar.closest("details");
    garagem.usar(usar.dataset.usar);
    const v = garagem.ativo();
    if (v) anunciar(`Comprando para ${core.labelVeiculo(v)}`);
    if (menu) {
      menu.removeAttribute("open");
      menu.querySelector("summary")?.focus();
    }
    usar.closest("dialog")?.close(); // a gaveta devolve o foco a quem a abriu
    return;
  }
  const remover = e.target.closest?.("[data-remover]");
  if (remover) {
    const lista = remover.closest("[data-ds-garage-list]");
    const idx = lista ? [...lista.children].indexOf(remover.closest("li")) : -1;
    const caixa = remover.closest("[data-ds-strip]") ?? remover.closest("dialog");
    const menu = remover.closest("details");
    garagem.remover(remover.dataset.remover);
    anunciar("Veículo removido");
    const restantes = lista ? [...lista.querySelectorAll("[data-usar]")] : [];
    if (restantes.length) {
      restantes[Math.min(Math.max(idx, 0), restantes.length - 1)].focus();
    } else {
      menu?.removeAttribute("open");
      caixa?.querySelector("[data-marca]")?.focus();
    }
    return;
  }
  const trocar = e.target.closest?.("[data-ds-trocar]");
  if (trocar) {
    const strip = trocar.closest("[data-ds-strip]");
    if (!strip) return;
    strip.dataset.estado = "trocando";
    strip.querySelector("[data-marca]")?.focus();
    return;
  }
  const cancelar = e.target.closest?.("[data-ds-cancelar-troca]");
  if (cancelar) {
    const strip = cancelar.closest("[data-ds-strip]");
    if (!strip) return;
    strip.dataset.estado = garagem.ativo() ? "veiculo" : "vazio";
    (garagem.ativo() ? strip.querySelector("[data-ds-trocar]") : strip.querySelector("[data-marca]"))?.focus();
    return;
  }
  const meu = e.target.closest?.("[data-ds-meu-veiculo]");
  if (meu && !garagem.ativo()) {
    // sem veículo salvo: "Meu veículo" abre o seletor em vez de ir pra página
    if (window.ArpineDrawer?.abrir("ds-seletor-dialog", meu)) e.preventDefault();
  }
});

document.addEventListener(core.EVENTO, (e) => {
  if (e.detail?.ativoMudou) document.querySelectorAll("[data-ds-strip]").forEach((el) => { delete el.dataset.estado; });
  render();
});
render();
